module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Card', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(" Tambah Omset")]), _vm._v(" "), _c('Button', {
    attrs: {
      "slot": "extra",
      "disabled": !_vm.isDataFilled,
      "loading": _vm.isSubmitButton,
      "type": "success",
      "size": "small"
    },
    on: {
      "click": _vm.actionPost
    },
    slot: "extra"
  }, [(!_vm.isSubmitButton) ? _c('span', [_vm._v("Simpan Data")]) : _c('span', [_vm._v("Sedang diproses.....")])]), _vm._v(" "), _c('Row', {
    staticClass: "code-row-bg ivu-row-flex-space-between",
    attrs: {
      "type": "flex"
    }
  }, [_c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "format": "yyyy-MM-dd",
      "placeholder": "Pilih Tanggal"
    },
    model: {
      value: (_vm.omsetDate),
      callback: function($$v) {
        _vm.omsetDate = $$v
      },
      expression: "omsetDate"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "3",
      "align": "right"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_vm._v("Max. 100 baris")])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('HotTable', {
    ref: "hotTableComponent",
    attrs: {
      "settings": _vm.hotSettings
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6135d6e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/omset/OmsetAdd.vue
// module id = 1818
// module chunks = 1